module.exports = __webpack_public_path__ + "media/components/maps/incidents/pins/Criminality-d58219c8d7cabe6c12e72f7a051f766a.png";